<!--<c-footer>-->
<div>
  <a href='https://convivepro.cl/' target="_blank" rel="noopener">Convivepro</a>
  <span> &copy; 2025 InnovaX</span>
</div>
<div class="ms-auto">
  Powered by
  <a href='https://coreui.io/angular' target="_blank" rel="noopener">
    <span> InnovaX</span>
  </a>
</div>
<!--</c-footer>-->
